const storageKey = (path) => `grozny:scroll:${path}`;

export function currentListPath() {
  return `${window.location.pathname}${window.location.search}`;
}

export function saveListScroll(listingId) {
  try {
    sessionStorage.setItem(
      storageKey(currentListPath()),
      JSON.stringify({ y: window.scrollY, listingId: listingId || null })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function readListScroll(path) {
  try {
    const raw = sessionStorage.getItem(storageKey(path));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function restoreListScroll(path, { allowY = true } = {}) {
  const saved = readListScroll(path);
  if (!saved) return false;
  if (saved.listingId) {
    const el = document.querySelector(`[data-testid="listing-card-${saved.listingId}"]`);
    if (el) {
      el.scrollIntoView({ block: "center" });
      return true;
    }
    if (!allowY) return false;
  }
  if (allowY && typeof saved.y === "number") {
    window.scrollTo(0, saved.y);
    return true;
  }
  return false;
}
